import { Component, OnInit } from '@angular/core';
import { InputBase } from '../../common/api/common/InputBase';
import { SettingsGetOutput } from '../../common/api/SettingsGet';
import { TranslateService } from "../../common/variables/translate-service";
import { GlobalVariableService } from "../../common/variables/global-variable";
import { GlobalService } from "../../common/services/global.service";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'sen-app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  fileToUpload: any;
  imageUrl: string;
  imageBlob: Blob;
  form: FormGroup;

  constructor(public translate: TranslateService, private formBuilder: FormBuilder, public global: GlobalVariableService, public globalService: GlobalService) {
    this.form = this.formBuilder.group({
      blobImage: new FormControl(null, Validators.required)
    })
  }

  ngOnInit(): void {
    this.getSettingData();
  }

  handlefileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    let reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = (event: any) => {
      this.imageBlob = event.target.result;
      this.imageUrl = event.target.result;
    };
  }

  getSettingData() {
    let qParam: InputBase = {
      cmd: this.global.SettingsGet
    }
    this.globalService.getData(qParam).subscribe((data: SettingsGetOutput) => {
      if (data.ok.data) {
        this.imageUrl = data.ok.data.logoURL;
      }
    })
  }

  saveSettingData() {
    if (!this.imageUrl || !this.imageBlob) {
      this.form.markAllAsTouched();
      return;
    }
    let qParam: InputBase = {
      cmd: this.global.SettingsSave
    }
    let option = {
      image: this.imageBlob
    }
    this.globalService.postData(qParam, option).subscribe((data: SettingsGetOutput) => {
      if (data.ok.data) {
        this.getSettingData()
      }
    })
  }
}
